import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IPortalDirectorsListState } from '../states/portal-directors-list.state';

export const selectPortalDirectorsListState = createFeatureSelector<IPortalDirectorsListState>('portalDirectorsList');

export const selectPortalDirectorsListFullState = createSelector(
  selectPortalDirectorsListState,
  (state: IPortalDirectorsListState) => state
);
